import { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';
import { PriceInterface } from '@valk-nx/core/lib/interfaces/price.interface';

import { RoomFacilities } from './content.interface';

export function imageSchemeOrg(
	images: PhotoInterface[],
	width: number,
	height: number,
	useArray = false,
) {
	if (images.length === 0) {
		return undefined;
	}

	const createImageObject = (image: PhotoInterface) => ({
		'@type': 'ImageObject' as const,
		url: image.src,
		name: image.alt,
		width: {
			'@type': 'QuantitativeValue' as const,
			value: width,
			unitCode: 'E37',
		},
		height: {
			'@type': 'QuantitativeValue' as const,
			value: height,
			unitCode: 'E37',
		},
	});

	return {
		image: useArray
			? images.map(createImageObject)
			: createImageObject(images[0]),
	};
}

export function amenitySchemeOrg(amenities: RoomFacilities) {
	const { sleepingComfort, bathroom, misc, generic } = amenities;
	return {
		amenityFeature: {
			'@type': 'LocationFeatureSpecification',
			value: 'True',
			name: [
				...(sleepingComfort || []),
				...(bathroom || []),
				...(misc || []),
				...(generic || []),
			],
		},
	};
}

export function offersSchemeOrg(price: PriceInterface, brand: string) {
	return {
		offers: {
			'@type': 'Offer',
			offeredBy: { '@id': brand },
			seller: { '@id': brand },
			businessFunction: {
				'@type': 'BusinessFunction',
				url: 'http://purl.org/goodrelations/v1#LeaseOut',
			},
			eligibleCustomerType: {
				'@type': 'BusinessEntityType',
				url: 'http://purl.org/goodrelations/v1#Enduser',
			},
			priceSpecification: {
				'@type': 'UnitPriceSpecification',
				minPrice: price.amount,
				priceCurrency: price.currency || 'EUR',
				unitCode: 'DAY',
			},
			acceptedPaymentMethod: [
				{
					'@type': 'PaymentMethod',
					'@id': 'http://purl.org/goodrelations/v1#ByBankTransferInAdvance',
				},
				{
					'@type': 'PaymentMethod',
					'@id': 'http://purl.org/goodrelations/v1#Cash',
				},
				{
					'@type': 'PaymentMethod',
					'@id': 'http://purl.org/goodrelations/v1#DirectDebit',
				},
				{
					'@type': 'PaymentMethod',
					'@id': 'http://purl.org/goodrelations/v1#PayPal',
				},
			],
		},
	};
}
